import React, { useEffect, useState } from 'react'
import SectionSubHeading from '@/components/SectionSubHeading'
import getUserGeo from '@/lib/getUserGeo'
import highQualityLocationsWhitelist from '@/constants/highQualityLocationsWhitelist'
import convertToKebabCase from '@/utils/convertToKebabCase'
import WorldwideSearchRefinement from './WorldwideSearchRefinement'
import { isHighQualityNonUSCountryCode } from '@/domain/country'

const USCanonicalPopularDestinationsSubHeader = ({ slug }) => {
  const [userCountryCode, setUserCountryCode] = useState(undefined)

  useEffect(() => {
    const fetchUserCountryCode = async () => {
      try {
        const userGeo = await getUserGeo()
        setUserCountryCode(userGeo.country_code ?? null)
      } catch (err) {
        setUserCountryCode(null)
      }
    }
    fetchUserCountryCode()
  }, [])

  return (
    <SubHeaderText
      slug={slug}
      userCountryCode={userCountryCode}
    />
  )
}

export default USCanonicalPopularDestinationsSubHeader

const SubHeaderText = ({ slug, userCountryCode }) => {
  const countryCodesToNames = highQualityLocationsWhitelist.countryCodesToNames
  const linkCss =
    'text-gray-1100 font-semibold underline sm:no-underline hover:underline'

  const CountryLink = ({ countryCode }) => {
    return (
      <a
        className={linkCss}
        href={`/${convertToKebabCase(
          countryCodesToNames[countryCode]
        )}/${slug}`}
      >
        {countryCodesToNames[countryCode]}
      </a>
    )
  }

  return (
    <SectionSubHeading tag="p">
      Showing US centers, switch to{' '}
      {isHighQualityNonUSCountryCode(userCountryCode) ? (
        <CountryLink
          slug={slug}
          countryCode={userCountryCode}
        />
      ) : (
        <WorldwideSearchRefinement
          userCountryCode={userCountryCode}
          className={linkCss}
        />
      )}
    </SectionSubHeading>
  )
}
